
import React from 'react';
import { useTranslation } from 'react-i18next';
import Navbar from '@/components/Navbar';
import HeroSection from '@/components/HeroSection';
import SwitchPackages from '@/components/SwitchPackages';
import HomeWhySwitch from '@/components/HomeWhySwitch';
import FeaturedIn from '@/components/FeaturedIn';
import Footer from '@/components/Footer';
import SEO from '@/components/SEO';

const Index = () => {
  const { t } = useTranslation('index');

  return (
    <div className="min-h-screen flex flex-col">
      <SEO 
        title={t('meta.title')}
        description={t('meta.description')}
        url="/"
      />
      <Navbar />
      <main className="flex-grow">
        <HeroSection />
        <HomeWhySwitch />
        <FeaturedIn />
        <SwitchPackages />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
